export const routes = {
  example: 'example',
  auth: {
    auth_url: '/Auth/v1.0/auth-url',
    get_tokens: '/Auth/v1.0/tokens',
    logout: '/Auth/v1.0/logout',
    verify_token: '/Auth/v1.0/verify-token',
  },
};
